import React from 'react';

import { useDeviceInformationWidgetQuery } from 'generated/graphql';



export interface IDeviceInformation {
  model: string;
  softwareVersion: string;
  sku: string;
  serialNumber: string;
}

export interface IData {
  device: IDeviceInformation;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useDeviceInformationWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const returnAuthorization = tuple.data?.tier1ReturnAuthorization;
      const itemReceipt = returnAuthorization?.itemReceipt;
      const data: IData = {
        device: {
          model: itemReceipt?.item.name ?? returnAuthorization?.item.name ?? 'N/A',
          softwareVersion: returnAuthorization?.qualityControlCheck?.softwareVersion.name ?? '-',
          sku: itemReceipt?.item.sku ?? returnAuthorization?.item.sku ?? 'N/A',
          serialNumber: (itemReceipt?.serialNumber ?? returnAuthorization?.expectedSerialNumber) || 'N/A'
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
